const zipArray = (a1, a2) => {
  return a1.map((a, idx) => [a, a2[idx]]);
};

export { zipArray };
